import { render, staticRenderFns } from "./TableReteManagement.vue?vue&type=template&id=4f80e7a0"
import script from "./TableReteManagement.vue?vue&type=script&lang=js"
export * from "./TableReteManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports